import { FC, useContext, useMemo } from 'react';

import { ContextMenu, Table, useContextMenu } from '@smartshell/ui-kit';
import cn from 'classnames';
import { Column } from 'react-table';

import { LayoutContext } from 'components/Layout';
import { LocalizationContext } from 'localization';
import { IAutorunApplication } from 'types';

import s from './AutorunTable.module.scss';
import { IAutorunTableProps } from './interfaces';
import { useContextMenuItems } from './useContextMenuItems';
import { getApplicationFromPath } from './utils';

export const AutorunTable: FC<IAutorunTableProps> = ({
  autorun,
  editApplication,
  deleteApplication,
}) => {
  const { t } = useContext(LocalizationContext);
  const layoutElement = useContext(LayoutContext);

  const COLUMNS: Array<Column<IAutorunApplication>> = useMemo(
    () => [
      {
        Header: t('setting.shell.autorun.app'),
        accessor: 'path',
        Cell: ({ value }) => getApplicationFromPath(value),
      },
      {
        Header: t('setting.shell.autorun.rule'),
        accessor: 'kill_on_seance',
        Cell: ({ value }) => (
          <span className={cn(s['work-rules'], value && s.workRules_violet)}>
            {t(
              value
                ? 'setting.shell.autorun.rule.untilSession'
                : 'setting.shell.autorun.rule.always'
            )}
          </span>
        ),
      },
    ],
    [t]
  );

  const {
    contextMenuData,
    onContextMenu,
    closeContextMenu,
    cursorPosition,
    onTouchMove,
    onTouchEnd,
    onTouchStart,
  } = useContextMenu<IAutorunApplication>();

  const items = useContextMenuItems(editApplication, deleteApplication);

  return (
    <>
      {contextMenuData && cursorPosition && (
        <ContextMenu
          layoutElement={layoutElement}
          data={contextMenuData}
          items={items}
          closeContextMenu={closeContextMenu}
          position={cursorPosition}
        />
      )}
      <Table
        className={s.table}
        data={autorun}
        columns={COLUMNS}
        onRowClick={(event, row, table) => {
          table.toggleAllRowsSelected(false);
          row.toggleRowSelected(!row.isSelected);
        }}
        onRowDoubleClick={(event, client, row) => {
          row.toggleRowSelected(true);
          editApplication(row.original);
        }}
        onContextMenu={onContextMenu}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      />
    </>
  );
};
